/**
 * Workshop city cart — live capacity enforce for drawer / cart page.
 */
(function (global) {
  'use strict';

  if (global.__WCF_CART_LIVE_BOOTED) return;
  global.__WCF_CART_LIVE_BOOTED = true;

  var DEFAULT_MAX_QTY = 20;
  var PROD_API_BASE = 'https://adapter.aogen.com.au';
  var LIVE_STATE_PATH = '/api/public/workshop-venue/event-live-state';

  function resolveAogenApiBase() {
    var raw =
      (typeof global.__AOGEN_API_BASE__ === 'string' && global.__AOGEN_API_BASE__.trim()) ||
      (typeof global.__WB_FORMS_API_BASE__ === 'string' && global.__WB_FORMS_API_BASE__.trim()) ||
      '';
    raw = String(raw || '').replace(/\/+$/, '');
    return raw || PROD_API_BASE;
  }
  var DEFAULT_CART_OPEN_POLL_MS = 10000;
  var refreshTimer = null;
  var drawerPollTimer = null;
  var drawerPollBound = false;
  var xCartPatched = false;

  var liveCache = {
    as_of: null,
    states: {},
  };

  var lastLiveRefresh = {
    ok: true,
    attempted: false,
    missingGids: [],
    requestedGids: [],
  };

  var refreshInFlight = null;
  var bannerSyncInFlight = null;

  function configRoot() {
    return {
      getAttribute: function (name) {
        if (name !== 'data-section-id') return '';
        var page = global.document && global.document.getElementById('WcfConfig-cart-page');
        return page ? 'cart-page' : 'cart-drawer';
      },
    };
  }

  function readConfig() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.readBootstrap === 'function') {
      return CFG.readBootstrap(configRoot());
    }
    var ids = ['WcfConfig-cart-drawer', 'WcfConfig-cart-page'];
    for (var i = 0; i < ids.length; i++) {
      var script = global.document && global.document.getElementById(ids[i]);
      if (script && script.textContent) {
        try {
          return JSON.parse(script.textContent);
        } catch (_) {}
      }
    }
    return {};
  }

  function cssEscape(value) {
    if (global.CSS && typeof global.CSS.escape === 'function') return global.CSS.escape(String(value));
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function enforceConfig() {
    return readConfig().enforce || {};
  }

  function gatesConfig() {
    return readConfig().gates || {};
  }

  function policyConfig() {
    return readConfig().policy || {};
  }

  function verifySoftMode() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.verifySoftMode === 'function') return CFG.verifySoftMode();
    return false;
  }

  function validateFailModeOpen() {
    if (verifySoftMode()) return true;
    return String(policyConfig().validate_fail_mode || 'closed').toLowerCase() === 'open';
  }

  function cartOpenPollIntervalMs() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.cartOpenPollIntervalMs === 'function') {
      return CFG.cartOpenPollIntervalMs(configRoot());
    }
    return DEFAULT_CART_OPEN_POLL_MS;
  }

  function parseTimestampMs(value) {
    if (value == null || value === '') return NaN;
    var t = new Date(value).getTime();
    return Number.isFinite(t) ? t : NaN;
  }

  function maxStaleMsBeforeQtyChange() {
    var gates = gatesConfig();
    if (gates.max_stale_ms_before_qty_change != null && gates.max_stale_ms_before_qty_change !== '') {
      return Number(gates.max_stale_ms_before_qty_change);
    }
    if (gates.max_stale_ms_before_add != null && gates.max_stale_ms_before_add !== '') {
      return Number(gates.max_stale_ms_before_add);
    }
    return 15000;
  }

  function capacityAsOfMs(eventGid, slot) {
    var live = liveStateForGid(eventGid);
    var raw =
      (live && live.capacity_as_of != null && live.capacity_as_of !== '' && live.capacity_as_of) ||
      (slot && slot.capacity_as_of) ||
      liveCache.as_of;
    return parseTimestampMs(raw);
  }

  function isCapacityStale(eventGid, slot, maxStaleMs) {
    maxStaleMs = Number(maxStaleMs);
    if (!Number.isFinite(maxStaleMs) || maxStaleMs <= 0) return false;
    var asOfMs = capacityAsOfMs(eventGid, slot);
    if (!Number.isFinite(asOfMs)) return true;
    return Date.now() - asOfMs > maxStaleMs;
  }

  function hasLiveStateForGid(eventGid) {
    var live = liveStateForGid(eventGid);
    if (!live || typeof live !== 'object') return false;
    return (
      (live.capacity_remaining != null && live.capacity_remaining !== '') ||
      (live.status != null && live.status !== '') ||
      (live.display_status != null && live.display_status !== '') ||
      (live.capacity_as_of != null && live.capacity_as_of !== '')
    );
  }

  function missingLiveStateGids(gids) {
    var missing = [];
    (gids || []).forEach(function (gid) {
      if (!hasLiveStateForGid(gid)) missing.push(gid);
    });
    return missing;
  }

  function resolveLiveStateUrl() {
    return resolveAogenApiBase() + LIVE_STATE_PATH;
  }

  function lineMetaFromEl(el) {
    if (!el) return null;
    var host = el.closest('[data-wcf-cart-line]');
    if (!host || host.getAttribute('data-wcf-cart-line') !== '1') return null;
    return {
      lineKey: host.getAttribute('data-cart-line-key') || '',
      eventGid: host.getAttribute('data-event-gid') || '',
    };
  }

  function isWorkshopLineKey(lineKey) {
    if (!lineKey) return false;
    var host = global.document && global.document.querySelector('[data-cart-line-key="' + cssEscape(lineKey) + '"]');
    return !!(host && host.getAttribute('data-wcf-cart-line') === '1');
  }

  function collectEventGidsFromDom() {
    var seen = {};
    var gids = [];
    if (!global.document) return gids;
    global.document.querySelectorAll('[data-wcf-cart-line="1"][data-event-gid]').forEach(function (el) {
      var gid = String(el.getAttribute('data-event-gid') || '').trim();
      if (!gid || seen[gid]) return;
      seen[gid] = true;
      gids.push(gid);
    });
    return gids;
  }

  function fetchCart() {
    var rootPath = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    return fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function lineQty(cart, lineKey) {
    if (!cart || !cart.items || !lineKey) return 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === lineKey) return cart.items[i].quantity || 0;
    }
    return 0;
  }

  function eventGidFromCartItem(item) {
    var F = global.WorkshopCityFlow;
    if (F && typeof F.eventGidFromCartLine === 'function') {
      return F.eventGidFromCartLine(item);
    }
    if (!item || !item.properties) return '';
    return String(item.properties._event_metaobject_gid || item.properties._event_id || '').trim();
  }

  function liveStateForGid(eventGid) {
    var gid = String(eventGid || '').trim();
    if (!gid) return {};
    if (liveCache.states[gid]) return liveCache.states[gid];
    var API = global.WorkshopCityEvents;
    if (API && typeof API.eventIdAliases === 'function') {
      var aliases = API.eventIdAliases(gid);
      for (var i = 0; i < aliases.length; i++) {
        if (liveCache.states[aliases[i]]) return liveCache.states[aliases[i]];
      }
    }
    return {};
  }

  function canonicalEventId(eventGid) {
    var gid = String(eventGid || '').trim();
    if (!gid) return '';
    var live = liveStateForGid(gid);
    return String(live.canonical_event_id || gid).trim();
  }

  function isWorkshopAddonItem(item) {
    if (!item || !item.properties) return false;
    var props = item.properties;
    if (!Array.isArray(props)) return props._workshop_addon === 'true';
    for (var i = 0; i < props.length; i++) {
      var row = props[i];
      if (!row) continue;
      var k = row[0] != null ? row[0] : row.name;
      var v = row[1] != null ? row[1] : row.value;
      if (k === '_workshop_addon' && String(v) === 'true') return true;
    }
    return false;
  }

  function cartSeatsForPoolAfterUpdate(cart, eventGid, lineKey, desiredQty) {
    if (!cart || !cart.items) return desiredQty || 0;
    var API = global.WorkshopCityEvents;
    var slot = buildSlotFromLive(eventGid);
    var targetPool =
      API && typeof API.capacityPoolKeyFromSlot === 'function' ? API.capacityPoolKeyFromSlot(slot) : '';
    if (API && typeof API.capacityPoolKeyFromProps === 'function' && targetPool) {
      var poolTotal = 0;
      var poolHit = false;
      cart.items.forEach(function (item) {
        if (!item || isWorkshopAddonItem(item)) return;
        var itemPool = API.capacityPoolKeyFromProps(item.properties);
        if (!itemPool || !targetPool) return;
        var same =
          API.eventIdAliases &&
          API.eventIdAliases(targetPool).some(function (alias) {
            return API.eventIdAliases(itemPool).indexOf(alias) !== -1;
          });
        if (!same) return;
        poolHit = true;
        poolTotal += item.key === lineKey ? desiredQty || 0 : item.quantity || 0;
      });
      if (poolHit) return poolTotal;
    }
    if (API && typeof API.seatsInCartForEvent === 'function' && typeof API.eventIdAliases === 'function') {
      var targetAliases = API.eventIdAliases(eventGid);
      if (!targetAliases.length) return desiredQty || 0;
      var total = 0;
      cart.items.forEach(function (item) {
        if (!item || isWorkshopAddonItem(item)) return;
        var itemGid = eventGidFromCartItem(item);
        if (!itemGid) return;
        var itemAliases = API.eventIdAliases(itemGid);
        var matches = targetAliases.some(function (alias) {
          return itemAliases.indexOf(alias) !== -1;
        });
        if (!matches) return;
        total += item.key === lineKey ? desiredQty || 0 : item.quantity || 0;
      });
      return total;
    }
    var targetCanonical = canonicalEventId(eventGid);
    if (!targetCanonical) return desiredQty || 0;
    var poolTotal = 0;
    (cart.items || []).forEach(function (item) {
      if (!item || isWorkshopAddonItem(item)) return;
      var gid = eventGidFromCartItem(item);
      if (!gid || canonicalEventId(gid) !== targetCanonical) return;
      poolTotal += item.key === lineKey ? desiredQty || 0 : item.quantity || 0;
    });
    return poolTotal;
  }

  function buildSlotFromLive(eventGid) {
    var gid = String(eventGid || '');
    var live = liveStateForGid(gid);
    var slot = {
      gid: gid,
      status: live.status || 'active',
      capacity_remaining: live.capacity_remaining,
      display_status: live.display_status,
      capacity_as_of: live.capacity_as_of || liveCache.as_of,
      canonical_event_id: live.canonical_event_id,
      capacity_group_id: live.capacity_group_id,
    };
    if (!hasLiveStateForGid(gid)) return slot;
    slot._live_state = live;
    slot._live_state_fresh = true;
    var API = global.WorkshopCityEvents;
    if (API && typeof API.mergeSlotWithLive === 'function') {
      return API.mergeSlotWithLive(slot, liveCache.states, liveCache.as_of) || slot;
    }
    return slot;
  }

  var UNVERIFIED_WORKSHOP_MSG =
    'This workshop item is missing event details. Please remove it from your cart and add it again.';

  function clearLiveStateForGids(gids) {
    if (!gids || !gids.length) return;
    var API = global.WorkshopCityEvents;
    gids.forEach(function (gid) {
      if (API && typeof API.eventIdAliases === 'function') {
        API.eventIdAliases(gid).forEach(function (alias) {
          delete liveCache.states[alias];
        });
      }
      delete liveCache.states[gid];
    });
  }

  function refreshLiveResult(fetchOk, fetchAttempted, requestedGids) {
    return {
      cache: liveCache,
      fetchOk: fetchOk,
      fetchAttempted: fetchAttempted,
      missingGids: lastLiveRefresh.missingGids,
      requestedGids: requestedGids || lastLiveRefresh.requestedGids || [],
    };
  }

  function rememberLiveRefreshResult(fetchOk, fetchAttempted, requestedGids) {
    lastLiveRefresh.ok = fetchOk;
    lastLiveRefresh.attempted = fetchAttempted;
    lastLiveRefresh.requestedGids = (requestedGids || []).slice();
    if (fetchAttempted) {
      if (fetchOk) {
        lastLiveRefresh.missingGids = missingLiveStateGids(requestedGids);
      } else {
        lastLiveRefresh.missingGids = (requestedGids || []).slice();
      }
    } else {
      lastLiveRefresh.missingGids = [];
    }
    return refreshLiveResult(fetchOk, fetchAttempted, requestedGids);
  }

  function refreshLiveForGids(gids, force, fetchOptions) {
    fetchOptions = fetchOptions || {};
    var requestedGids = (gids || []).slice();
    var gates = gatesConfig();
    if (!force && gates.live_fetch_on_cart_open === false && gates.live_fetch_on_qty_change === false) {
      return Promise.resolve(rememberLiveRefreshResult(true, false, requestedGids));
    }
    if (!requestedGids.length) {
      return Promise.resolve(rememberLiveRefreshResult(true, false, requestedGids));
    }
    var API = global.WorkshopCityEvents;
    if (!API || typeof API.fetchLiveState !== 'function') {
      clearLiveStateForGids(requestedGids);
      return Promise.resolve(rememberLiveRefreshResult(false, true, requestedGids));
    }
    var liveFetchOpts = { url: resolveLiveStateUrl() };
    if (fetchOptions.applyMeta === false) {
      liveFetchOpts.applyMeta = false;
    } else {
      liveFetchOpts.root = configRoot();
    }
    return API.fetchLiveState(requestedGids, liveFetchOpts)
      .then(function (r) {
        var states = (r && r.states) || {};
        var hasStates = Object.keys(states).length > 0;
        var fetchOk = !!(r && r.ok !== false && hasStates);
        if (hasStates) {
          clearLiveStateForGids(requestedGids);
          liveCache.states = Object.assign({}, liveCache.states, states);
          if (r.as_of) liveCache.as_of = r.as_of;
        } else if (!fetchOk) {
          clearLiveStateForGids(requestedGids);
        }
        return rememberLiveRefreshResult(fetchOk, true, requestedGids);
      })
      .catch(function () {
        clearLiveStateForGids(requestedGids);
        return Promise.resolve(rememberLiveRefreshResult(false, true, requestedGids));
      });
  }

  function enforceUsesLiveCapacityCap() {
    return String((enforceConfig().source || 'live_state_only')).toLowerCase() === 'live_state_only';
  }

  function maxQtyForLine(cart, lineKey, eventGid, slot) {
    var enforce = enforceConfig();
    var maxPerOrder =
      enforce.max_qty_per_order != null ? Number(enforce.max_qty_per_order) : DEFAULT_MAX_QTY;
    if (!Number.isFinite(maxPerOrder) || maxPerOrder <= 0) maxPerOrder = DEFAULT_MAX_QTY;

    var liveCap = null;
    if (slot && slot.capacity_remaining != null && slot.capacity_remaining !== '') {
      var capNum = Number(slot.capacity_remaining);
      if (Number.isFinite(capNum) && capNum >= 0) liveCap = capNum;
    }

    var capMax = maxPerOrder;
    if (liveCap != null) {
      capMax = enforceUsesLiveCapacityCap() ? liveCap : Math.min(maxPerOrder, liveCap);
    }

    var totalInCart = 0;
    var API = global.WorkshopCityEvents;
    if (API && typeof API.seatsInCartForEvent === 'function') {
      totalInCart = API.seatsInCartForEvent(eventGid, cart);
    } else {
      var F = global.WorkshopCityFlow;
      totalInCart = F && F.seatsInCartForEvent ? F.seatsInCartForEvent(cart, eventGid) : 0;
    }
    var thisQty = lineQty(cart, lineKey);
    var others = totalInCart - thisQty;
    var room = capMax - others;
    if (room < 0) room = 0;
    if (liveCap != null && enforceUsesLiveCapacityCap()) {
      return room;
    }
    return Math.min(maxPerOrder, room);
  }

  function hasLiveCapacity(slot) {
    return !!(slot && slot.capacity_remaining != null && slot.capacity_remaining !== '');
  }

  function normalizeListingStatus(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
  }

  function slotClosedForIncrease(slot) {
    function listingClosed(status, displayStatus) {
      var st = normalizeListingStatus(status);
      var ds = normalizeListingStatus(displayStatus);
      return (
        st === 'sold_out' ||
        ds === 'sold_out' ||
        ds === 'hidden' ||
        ds === 'ended' ||
        st === 'draft' ||
        st === 'completed' ||
        st === 'cancelled'
      );
    }
    var live = slot && slot._live_state;
    return (
      listingClosed(slot && slot.status, slot && slot.display_status) ||
      !!(live && listingClosed(live.status, live.display_status))
    );
  }

  function closedSessionMessage(slot) {
    var live = slot && slot._live_state;
    var st = normalizeListingStatus((slot && slot.status) || (live && live.status));
    var ds = normalizeListingStatus((slot && slot.display_status) || (live && live.display_status));
    if (st === 'cancelled') return 'This session was cancelled.';
    if (ds === 'ended' || st === 'completed') return 'This session has ended.';
    if (ds === 'hidden' || st === 'draft') return 'This session is no longer available.';
    if (ds === 'sold_out' || st === 'sold_out') return 'This session is sold out.';
    return 'This session is no longer available.';
  }

  function validateLineUpdate(cart, lineKey, eventGid, desiredQty) {
    if (gatesConfig().validate_before_cart_update !== true) {
      return Promise.resolve(null);
    }
    var API = global.WorkshopCityEvents;
    if (!API || typeof API.fetchCapacityValidate !== 'function') {
      if (validateFailModeOpen()) return Promise.resolve(null);
      return Promise.resolve({
        blocked: true,
        qty: lineQty(cart, lineKey),
        allowedQty: lineQty(cart, lineKey),
        message: 'We could not verify workshop capacity right now. Please try again.',
      });
    }
    return API.fetchCapacityValidate(configRoot(), {
      event_id: eventGid,
      requested_total_qty: cartSeatsForPoolAfterUpdate(cart, eventGid, lineKey, desiredQty),
      current_qty: lineQty(cart, lineKey),
      line_key: lineKey,
      intent: 'update_line',
    }).then(function (result) {
      if (result === null) return null;
      if (!result || result.allowed !== false) return null;
      var current = lineQty(cart, lineKey);
      var remaining = Number(result.capacity_remaining);
      var allowedQty = Number.isFinite(remaining)
        ? Math.max(0, remaining - (cartSeatsForPoolAfterUpdate(cart, eventGid, lineKey, 0) || 0))
        : current;
      return {
        blocked: true,
        qty: Math.min(current, allowedQty),
        allowedQty: allowedQty,
        message:
          result.message ||
          (allowedQty <= 0
            ? 'This session is sold out.'
            : 'Only ' + allowedQty + ' seat(s) remain for this session.'),
      };
    }).catch(function () {
      if (validateFailModeOpen()) return null;
      return {
        blocked: true,
        qty: lineQty(cart, lineKey),
        allowedQty: lineQty(cart, lineKey),
        message: 'We could not verify workshop capacity right now. Please try again.',
      };
    });
  }

  var STALE_CAPACITY_MSG =
    'Workshop availability data is out of date. Please try again in a moment.';
  var MISSING_LIVE_STATE_MSG =
    'We could not verify workshop availability right now. Please try again.';

  function currentLineQtyFromDom(lineKey, cart) {
    var fromCart = lineQty(cart, lineKey);
    if (fromCart > 0 || !lineKey) return fromCart;
    var inp = global.document && global.document.getElementById('cart-qty-' + lineKey);
    return parseInt((inp && inp.value) || '0', 10) || 0;
  }

  function eventGidsEquivalent(a, b) {
    var API = global.WorkshopCityEvents;
    if (API && typeof API.eventIdAliases === 'function') {
      var aList = API.eventIdAliases(a);
      var bList = API.eventIdAliases(b);
      for (var i = 0; i < aList.length; i++) {
        if (bList.indexOf(aList[i]) !== -1) return true;
      }
      return false;
    }
    return String(a || '').trim() === String(b || '').trim();
  }

  function liveRefreshCoversGids(currentGids) {
    var requested = lastLiveRefresh.requestedGids || [];
    currentGids = currentGids || [];
    if (!lastLiveRefresh.attempted) return false;
    if (!requested.length && !currentGids.length) return true;
    if (!requested.length) return false;
    if (!currentGids.length) return true;
    for (var i = 0; i < currentGids.length; i++) {
      var covered = false;
      for (var j = 0; j < requested.length; j++) {
        if (eventGidsEquivalent(currentGids[i], requested[j])) {
          covered = true;
          break;
        }
      }
      if (!covered) return false;
    }
    return true;
  }

  function liveRefreshStaleForGids(currentGids) {
    if (!currentGids || !currentGids.length) return false;
    if (!lastLiveRefresh.attempted) return true;
    return !liveRefreshCoversGids(currentGids);
  }

  function gateLineUpdate(lineKey, lineIndex, desiredQty) {
    desiredQty = parseInt(desiredQty, 10);
    if (!Number.isFinite(desiredQty) || desiredQty < 0) desiredQty = 0;

    if (!isWorkshopLineKey(lineKey)) {
      return Promise.resolve({ blocked: false, qty: desiredQty, allowedQty: desiredQty });
    }

    if (desiredQty === 0) {
      return Promise.resolve({ blocked: false, qty: 0, allowedQty: 0 });
    }

    var currentFromDom = currentLineQtyFromDom(lineKey, null);
    if (desiredQty <= currentFromDom) {
      return Promise.resolve({ blocked: false, qty: desiredQty, allowedQty: desiredQty });
    }

    var soft = verifySoftMode();
    var host = global.document.querySelector('[data-cart-line-key="' + cssEscape(lineKey) + '"]');
    var meta = lineMetaFromEl(host);
    if (!meta || !meta.eventGid) {
      if (soft) {
        return Promise.resolve({ blocked: false, qty: desiredQty, allowedQty: desiredQty });
      }
      var blockedQty = currentLineQtyFromDom(lineKey, null);
      return Promise.resolve({
        blocked: true,
        qty: blockedQty,
        allowedQty: blockedQty,
        message: UNVERIFIED_WORKSHOP_MSG,
      });
    }

    var gates = gatesConfig();
    var fetchFresh = gates.live_fetch_on_qty_change !== false || gates.validate_before_cart_update === true;

    // Qty increase: fetch this line's event directly (not refreshFromDom — shared in-flight /
    // skipped fetch can leave liveCache empty while lastLiveRefresh.ok stays true).
    var refreshPromise = fetchFresh
      ? refreshLiveForGids([meta.eventGid], true, { applyMeta: false })
      : refreshLiveForGids(collectEventGidsFromDom(), false);

    return refreshPromise.then(function (refreshResult) {
      return fetchCart().then(function (cart) {
        var slot = buildSlotFromLive(meta.eventGid);
        var currentQty = currentLineQtyFromDom(lineKey, cart);
        if (!cart) {
          if (soft) return { blocked: false, qty: desiredQty, allowedQty: desiredQty };
          return {
            blocked: true,
            qty: currentQty,
            allowedQty: currentQty,
            message: 'We could not verify workshop availability right now. Please try again.',
          };
        }
        var qtyIncrease = desiredQty > currentQty;
        var liveFetchDone =
          refreshResult && refreshResult.fetchAttempted === true && refreshResult.fetchOk === true;
        if (!soft && fetchFresh && qtyIncrease && refreshResult && refreshResult.fetchAttempted && !refreshResult.fetchOk) {
          return {
            blocked: true,
            qty: currentQty,
            allowedQty: currentQty,
            message: MISSING_LIVE_STATE_MSG,
          };
        }
        if (!soft && fetchFresh && qtyIncrease && liveFetchDone) {
          if (!hasLiveStateForGid(meta.eventGid)) {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: MISSING_LIVE_STATE_MSG,
            };
          }
          if (isCapacityStale(meta.eventGid, slot, maxStaleMsBeforeQtyChange())) {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: STALE_CAPACITY_MSG,
            };
          }
          if (!hasLiveCapacity(slot)) {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: MISSING_LIVE_STATE_MSG,
            };
          }
        }
        var listingClosed = slotClosedForIncrease(slot);
        var F = global.WorkshopCityFlow;
        if (listingClosed || (F && F.slotBookable && !F.slotBookable(slot))) {
          return {
            blocked: true,
            qty: currentQty,
            allowedQty: currentQty,
            message: closedSessionMessage(slot),
          };
        }
        var maxForLine = maxQtyForLine(cart, lineKey, meta.eventGid, slot);
        if (desiredQty > maxForLine) {
          var current = lineQty(cart, lineKey);
          return {
            blocked: true,
            qty: Math.min(current, maxForLine),
            allowedQty: maxForLine,
            message:
              maxForLine <= 0
                ? 'This session is sold out.'
                : 'Only ' + maxForLine + ' seat(s) remain for this session.',
          };
        }
        if (gates.validate_before_cart_update !== true) {
          return { blocked: false, qty: desiredQty, allowedQty: maxForLine };
        }
        return validateLineUpdate(cart, lineKey, meta.eventGid, desiredQty).then(function (validation) {
          return validation || { blocked: false, qty: desiredQty, allowedQty: maxForLine };
        });
      });
    }).catch(function (err) {
      if (global.__WCF_DIAG__ || global.__WB_DIAG__) {
        console.warn('[WorkshopCityCartLive] gateLineUpdate error', err);
      }
      if (soft) return { blocked: false, qty: desiredQty, allowedQty: desiredQty };
      var fallbackQty = currentLineQtyFromDom(lineKey, null);
      return {
        blocked: true,
        qty: fallbackQty,
        allowedQty: fallbackQty,
        message: 'We could not verify workshop availability right now. Please try again.',
      };
    });
  }

  function showLineError(lineKey, message) {
    var err = global.document && global.document.getElementById('LineItemError-' + lineKey);
    if (err) {
      err.classList.remove('hidden');
      var text = err.getElementsByClassName('cart-item__error-text')[0];
      if (text) text.innerHTML = message;
      return;
    }
    if (message) global.alert(message);
  }

  function clearLineError(lineKey) {
    var err = global.document && global.document.getElementById('LineItemError-' + lineKey);
    if (err) err.classList.add('hidden');
  }

  function syncInput(lineKey, qty) {
    var inp = global.document && global.document.getElementById('cart-qty-' + lineKey);
    if (inp) inp.value = qty;
  }

  var normalizeSeatsInFlight = null;
  /** Serialize seat normalize + +/-/bin so clear+add never races (stuck loading / wiped cart). */
  var seatMutationQueue = Promise.resolve();
  var LOADING_WATCHDOG_MS = 12000;

  function enqueueSeatMutation(fn) {
    var run = seatMutationQueue.then(function () {
      return Promise.resolve().then(fn);
    });
    // Keep queue alive after failures so later clicks still run.
    seatMutationQueue = run.catch(function () {
      return null;
    });
    return run;
  }

  function withLoadingWatchdog(api, itemId, workPromise) {
    var done = false;
    var timer = global.setTimeout(function () {
      if (done) return;
      done = true;
      if (global.__WCF_DIAG__ || global.__WB_DIAG__) {
        console.warn('[WorkshopCityCartLive] loading watchdog — clearing stuck UI');
      }
      finishWorkshopCartUi(api, itemId);
    }, LOADING_WATCHDOG_MS);
    return Promise.resolve(workPromise)
      .catch(function (err) {
        throw err;
      })
      .finally(function () {
        if (done) return;
        done = true;
        global.clearTimeout(timer);
        finishWorkshopCartUi(api, itemId);
      });
  }

  function cartRootPath() {
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  }

  function getCartSections() {
    if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
      return global.Alpine.store('xCartHelper')
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        });
    }
    return [];
  }

  function applyCartSections(data) {
    if (data && data.sections && global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
      global.Alpine.store('xCartHelper').reRenderSections(data.sections);
    }
    if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
      var bubble = global.document && global.document.querySelector('#cart-icon-bubble span');
      global.Alpine.store('xCartHelper').currentItemCount = parseInt(
        (bubble && bubble.innerHTML) || '0',
        10
      );
    }
    if (global.document) {
      global.document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    }
  }

  function isWorkshopCartItem(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;
    return p._workshop === 'true' || p._is_workshop === '1' || !!(p._event_metaobject_gid || p._event_id);
  }

  function findCartItem(cart, lineKey) {
    if (!cart || !cart.items || !lineKey) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === lineKey) return cart.items[i];
    }
    return null;
  }

  function workshopGroupKey(item) {
    if (!item) return '';
    var p = item.properties || {};
    return (
      String(item.variant_id || item.id || '') +
      '|' +
      String(p._event_metaobject_gid || p._event_id || '')
    );
  }

  function workshopSeatBaseFromItem(item) {
    var p = (item && item.properties) || {};
    var raw = String(p._unique || '').replace(/:seat:.*$/, '');
    if (raw) return raw;
    return (
      String(item.variant_id || item.id || '') +
      ':' +
      String(p._event_metaobject_gid || p._event_id || 'seat')
    );
  }

  /** Paid stack line (`:seat:stack`). Legacy `:seat:carrier` treated as paid during migrate. */
  function isPaidStackUnique(unique) {
    return /:seat:(stack|carrier)$/.test(String(unique || ''));
  }

  function copyItemProps(item) {
    var props = {};
    var src = (item && item.properties) || {};
    Object.keys(src).forEach(function (k) {
      if (src[k] != null && src[k] !== '') props[k] = String(src[k]);
    });
    return props;
  }

  function syncWorkshopPricesKeys(sourceItem, uniques) {
    return fetchCart().then(function (cart) {
      if (!cart) return null;
      var prices = {};
      try {
        if (cart.attributes && cart.attributes._workshop_prices) {
          prices = JSON.parse(cart.attributes._workshop_prices);
        }
      } catch (_) {}
      var oldUnique = sourceItem && sourceItem.properties && sourceItem.properties._unique;
      var cents =
        (oldUnique && prices[oldUnique]) ||
        (sourceItem &&
          sourceItem.properties &&
          (sourceItem.properties._resolved_price_cents || sourceItem.properties._resolved_price));
      (uniques || []).forEach(function (u) {
        if (u && cents) prices[u] = String(cents);
      });
      var keep = {};
      (cart.items || []).forEach(function (it) {
        var u = it.properties && it.properties._unique;
        if (u && prices[u] != null) keep[u] = prices[u];
        else if (u && it.properties && it.properties._resolved_price_cents) {
          keep[u] = String(it.properties._resolved_price_cents);
        }
      });
      (uniques || []).forEach(function (u) {
        if (u && prices[u] != null) keep[u] = prices[u];
      });
      return fetch(cartRootPath() + 'cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { _workshop_prices: JSON.stringify(keep) } }),
      }).catch(function () {
        return null;
      });
    });
  }

  function changeWorkshopLineQty(lineKey, qty, withSections) {
    var body = { id: lineKey, quantity: qty };
    if (withSections) {
      var sections = getCartSections();
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = (global.location && global.location.pathname) || '/';
      }
    }
    return fetch(cartRootPath() + 'cart/change.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error((data && data.description) || 'Unable to update cart');
        }
        if (withSections) applyCartSections(data);
        return data;
      });
    });
  }

  /** Batch qty updates — avoid sequential change.js (keys shift after first remove). */
  function updateWorkshopLineQuantities(updates, withSections) {
    var body = { updates: updates || {} };
    if (withSections) {
      var sections = getCartSections();
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = (global.location && global.location.pathname) || '/';
      }
    }
    return fetch(cartRootPath() + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error((data && data.description) || 'Unable to update cart');
        }
        if (withSections) applyCartSections(data);
        return data;
      });
    });
  }

  function addWorkshopLines(items, sourceItem, withSections) {
    var body = { items: items };
    if (withSections) {
      var sections = getCartSections();
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = (global.location && global.location.pathname) || '/';
      }
    }
    var uniques = items.map(function (it) {
      return it.properties && it.properties._unique;
    });
    return fetch(cartRootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error((data && data.description) || 'Unable to add seat');
        }
        return syncWorkshopPricesKeys(sourceItem, uniques).then(function () {
          if (withSections) applyCartSections(data);
          return data;
        });
      });
    });
  }

  function refreshCartSectionsOnly() {
    var sections = getCartSections();
    if (!sections.length) {
      if (global.document) {
        global.document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      }
      return Promise.resolve(null);
    }
    return fetch(cartRootPath() + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        sections: sections.join(','),
        sections_url: (global.location && global.location.pathname) || '/',
      }),
    }).then(function (res) {
      return res.json().then(function (data) {
        applyCartSections(data);
        return data;
      });
    });
  }

  /** Unit sell cents (pre-discount) for cheapest-SKU pick — Function discounts cheapest only. */
  function unitSellCents(item) {
    if (!item) return Number.POSITIVE_INFINITY;
    var p = item.properties || {};
    var resolved = parseInt(String(p._resolved_price_cents || p._resolved_price || ''), 10);
    if (Number.isFinite(resolved) && resolved > 0) return resolved;
    if (item.original_price != null && Number(item.original_price) > 0) return Number(item.original_price);
    if (item.price != null && Number(item.price) > 0) return Number(item.price);
    return Number.POSITIVE_INFINITY;
  }

  function groupUnitSellCents(lines) {
    var min = Number.POSITIVE_INFINITY;
    (lines || []).forEach(function (line) {
      var c = unitSellCents(line);
      if (c < min) min = c;
    });
    return min;
  }

  /**
   * Split shape: paid qty N-1 @ base:seat:stack + free qty1 @ base (no :seat: suffix).
   * Function discounts the newest cart line — always re-add stack first, base last.
   */
  function groupHasSplitShape(lines, total) {
    if (total <= 1) return lines.length === 1;
    if (lines.length !== 2) return false;
    var a = lines[0];
    var b = lines[1];
    var aPaid = isPaidStackUnique(a.properties && a.properties._unique);
    var bPaid = isPaidStackUnique(b.properties && b.properties._unique);
    if (aPaid === bPaid) return false;
    var paid = aPaid ? a : b;
    var free = aPaid ? b : a;
    if ((free.quantity || 0) !== 1) return false;
    if ((paid.quantity || 0) !== total - 1) return false;
    var base = workshopSeatBaseFromItem(free);
    if (String(free.properties && free.properties._unique) !== base) return false;
    if (String(paid.properties && paid.properties._unique) !== base + ':seat:stack') return false;
    return true;
  }

  /** One merged line (no paid-stack suffix) — Short Table ×2 style. */
  function groupHasMergeShape(lines, total) {
    if (total <= 0) return true;
    if (lines.length !== 1) return false;
    var line = lines[0];
    if ((line.quantity || 0) !== total) return false;
    if (isPaidStackUnique(line.properties && line.properties._unique)) return false;
    var base = workshopSeatBaseFromItem(line);
    return String(line.properties && line.properties._unique) === base;
  }

  function zeroWorkshopLines(lines, withSections) {
    var updates = {};
    (lines || []).forEach(function (line) {
      if (line && line.key) updates[line.key] = 0;
    });
    if (!Object.keys(updates).length) {
      return withSections ? refreshCartSectionsOnly() : Promise.resolve(null);
    }
    return updateWorkshopLineQuantities(updates, !!withSections);
  }

  function rebuildWorkshopGroup(lines, total, mode) {
    if (!lines || !lines.length) return Promise.resolve(null);
    var source = lines[0];
    var variantId = source.variant_id || source.id;
    var baseProps = copyItemProps(source);
    var seatBase = workshopSeatBaseFromItem(source);
    var split = mode === 'split' && total >= 2;
    if (total <= 0) return zeroWorkshopLines(lines, true);

    // Snapshot for restore if add fails after clear (same _unique cannot add-first).
    var restoreItems = (lines || []).map(function (line) {
      return {
        id: line.variant_id || line.id,
        quantity: line.quantity || 0,
        properties: copyItemProps(line),
      };
    }).filter(function (it) {
      return it.id && it.quantity > 0;
    });

    var items = [];
    if (!split) {
      var merged = copyItemProps({ properties: baseProps });
      merged._unique = seatBase;
      items.push({ id: variantId, quantity: total, properties: merged });
    } else {
      // Paid stack first, free base last (Function → newest line = $0).
      var paidLine = copyItemProps({ properties: baseProps });
      paidLine._unique = seatBase + ':seat:stack';
      items.push({ id: variantId, quantity: total - 1, properties: paidLine });
      var freeLine = copyItemProps({ properties: baseProps });
      freeLine._unique = seatBase;
      items.push({ id: variantId, quantity: 1, properties: freeLine });
    }

    return zeroWorkshopLines(lines, false)
      .then(function () {
        return addWorkshopLines(items, source, false);
      })
      .then(function () {
        return refreshCartSectionsOnly();
      })
      .catch(function (err) {
        return addWorkshopLines(restoreItems, source, true).then(function () {
          throw err;
        });
      });
  }

  function normalizeWorkshopSeatGroups(cart) {
    if (!cart || !cart.items) return Promise.resolve(null);
    var groups = {};
    cart.items.forEach(function (it) {
      if (!isWorkshopCartItem(it)) return;
      var key = workshopGroupKey(it);
      if (!key || key.endsWith('|')) return;
      if (!groups[key]) groups[key] = [];
      groups[key].push(it);
    });
    var keys = Object.keys(groups);
    if (!keys.length) return Promise.resolve(null);

    var cheapestKey = keys[0];
    var cheapestSell = groupUnitSellCents(groups[cheapestKey]);
    keys.forEach(function (key) {
      var sell = groupUnitSellCents(groups[key]);
      if (sell < cheapestSell) {
        cheapestSell = sell;
        cheapestKey = key;
      }
    });

    var chain = Promise.resolve();
    keys.forEach(function (key) {
      var lines = groups[key];
      var total = 0;
      lines.forEach(function (line) {
        total += line.quantity || 0;
      });
      // Plain qty: always one merged line (no paid/free seat split).
      var wantSplit = false;
      var ok = groupHasMergeShape(lines, total);
      if (ok) return;
      chain = chain.then(function () {
        return rebuildWorkshopGroup(lines, total, 'merge');
      });
    });
    return chain;
  }

  function splitMergedWorkshopLines() {
    if (normalizeSeatsInFlight) return normalizeSeatsInFlight;
    normalizeSeatsInFlight = enqueueSeatMutation(function () {
      return fetchCart().then(function (cart) {
        return normalizeWorkshopSeatGroups(cart);
      });
    })
      .catch(function (err) {
        if (global.__WCF_DIAG__ || global.__WB_DIAG__) {
          console.warn('[WorkshopCityCartLive] normalizeWorkshopSeatGroups', err);
        }
        return null;
      })
      .finally(function () {
        normalizeSeatsInFlight = null;
      });
    return normalizeSeatsInFlight;
  }

  function cheapestWorkshopGroupKey(cart) {
    var cheapestKey = '';
    var cheapestSell = Number.POSITIVE_INFINITY;
    var seen = {};
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      if (!isWorkshopCartItem(it)) return;
      var key = workshopGroupKey(it);
      if (!key || key.endsWith('|') || seen[key]) return;
      seen[key] = true;
      var lines = (cart.items || []).filter(function (row) {
        return isWorkshopCartItem(row) && workshopGroupKey(row) === key;
      });
      var sell = groupUnitSellCents(lines);
      if (sell < cheapestSell) {
        cheapestSell = sell;
        cheapestKey = key;
      }
    });
    return cheapestKey;
  }

  function bumpWorkshopStackFromLine(lineKey) {
    return fetchCart().then(function (cart) {
      var item = findCartItem(cart, lineKey);
      if (!item || !isWorkshopCartItem(item)) return null;
      var groupKey = workshopGroupKey(item);
      var lines = (cart.items || []).filter(function (it) {
        return isWorkshopCartItem(it) && workshopGroupKey(it) === groupKey;
      });
      var total = 0;
      lines.forEach(function (line) {
        total += line.quantity || 0;
      });
      var isCheapest = groupKey === cheapestWorkshopGroupKey(cart);
      var paid = null;
      var free = null;
      lines.forEach(function (line) {
        if (isPaidStackUnique(line.properties && line.properties._unique)) paid = line;
        else free = line;
      });
      // Non-cheapest SKU: keep one merged line (Short Table style)
      if (!isCheapest) {
        if (lines.length === 1) {
          return changeWorkshopLineQty(lines[0].key, total + 1, true);
        }
        return rebuildWorkshopGroup(lines, total + 1, 'merge');
      }
      if (paid) {
        return changeWorkshopLineQty(paid.key, (paid.quantity || 0) + 1, true);
      }
      // 1→2: full rebuild so stack is added before free (do not append stack after free).
      return rebuildWorkshopGroup(lines, total + 1, 'split');
    });
  }

  function workshopGroupLines(cart, lineKey) {
    var item = findCartItem(cart, lineKey);
    if (!item || !isWorkshopCartItem(item)) return { item: null, lines: [], total: 0 };
    var groupKey = workshopGroupKey(item);
    var lines = (cart.items || []).filter(function (it) {
      return isWorkshopCartItem(it) && workshopGroupKey(it) === groupKey;
    });
    var total = 0;
    lines.forEach(function (line) {
      total += line.quantity || 0;
    });
    return { item: item, lines: lines, total: total };
  }

  function setWorkshopGroupTotalFromLine(lineKey, desiredTotal) {
    desiredTotal = parseInt(desiredTotal, 10);
    if (!Number.isFinite(desiredTotal) || desiredTotal < 0) desiredTotal = 0;
    return fetchCart().then(function (cart) {
      var group = workshopGroupLines(cart, lineKey);
      if (!group.item) return null;
      var groupKey = workshopGroupKey(group.item);
      var wantSplit =
        groupKey === cheapestWorkshopGroupKey(cart) && desiredTotal >= 2;
      return rebuildWorkshopGroup(group.lines, desiredTotal, wantSplit ? 'split' : 'merge');
    });
  }

  /** Set this line's qty; other seats in the same variant+event group stay. */
  function setWorkshopLineQtyInGroup(lineKey, desiredLineQty) {
    desiredLineQty = parseInt(desiredLineQty, 10);
    if (!Number.isFinite(desiredLineQty) || desiredLineQty < 0) desiredLineQty = 0;
    return fetchCart().then(function (cart) {
      var group = workshopGroupLines(cart, lineKey);
      if (!group.item) return null;
      var thisQty = group.item.quantity || 0;
      var others = group.total - thisQty;
      var nextTotal = others + desiredLineQty;
      if (nextTotal <= 0) return zeroWorkshopLines(group.lines, true);
      // Single merged line: change.js only.
      if (
        groupHasMergeShape(group.lines, group.total) &&
        group.lines.length === 1 &&
        group.lines[0].key === lineKey
      ) {
        return changeWorkshopLineQty(lineKey, nextTotal, true);
      }
      var groupKey = workshopGroupKey(group.item);
      var wantSplit =
        groupKey === cheapestWorkshopGroupKey(cart) && nextTotal >= 2;
      return rebuildWorkshopGroup(group.lines, nextTotal, wantSplit ? 'split' : 'merge');
    });
  }

  function finishWorkshopCartUi(api, itemId) {
    if (api) api.loading = false;
    clearCartLoadingUi();
    var loadingEl = global.document && global.document.getElementById('loading-' + itemId);
    if (loadingEl) loadingEl.classList.add('hidden');
    var removeEl = global.document && global.document.getElementById('remove-' + itemId);
    if (removeEl) removeEl.style.display = 'block';
  }

  function liveRefreshResultFromLast() {
    return refreshLiveResult(
      lastLiveRefresh.ok,
      lastLiveRefresh.attempted,
      lastLiveRefresh.requestedGids
    );
  }

  function waitForDomEventGids(maxAttempts, delayMs) {
    maxAttempts = maxAttempts != null ? maxAttempts : 6;
    delayMs = delayMs != null ? delayMs : 100;

    function attempt(left) {
      var gids = collectEventGidsFromDom();
      if (gids.length || left <= 0) return Promise.resolve(gids);
      return new Promise(function (resolve) {
        global.setTimeout(function () {
          resolve(attempt(left - 1));
        }, delayMs);
      });
    }

    return attempt(maxAttempts);
  }

  function ensureLiveRefreshForDom() {
    return waitForDomEventGids().then(function (gids) {
      if (!gids.length) {
        rememberLiveRefreshResult(true, false, []);
        return liveCache;
      }
      if (refreshInFlight) return refreshInFlight;
      refreshInFlight = refreshLiveForGids(gids, true)
        .then(function (result) {
          return (result && result.cache) || liveCache;
        })
        .finally(function () {
          refreshInFlight = null;
        });
      return refreshInFlight;
    });
  }

  function refreshFromDom() {
    return ensureLiveRefreshForDom();
  }

  function checkDomBookabilityFromLive() {
    var gids = collectEventGidsFromDom();
    if (!gids.length) return { bookable: true };
    if (liveRefreshStaleForGids(gids)) {
      return { bookable: true, needsRefresh: true };
    }
    var soft = verifySoftMode();
    if (!soft && lastLiveRefresh.attempted && !lastLiveRefresh.ok) {
      return {
        bookable: false,
        message: MISSING_LIVE_STATE_MSG,
      };
    }
    if (!soft && lastLiveRefresh.attempted && lastLiveRefresh.ok && missingLiveStateGids(gids).length) {
      return {
        bookable: false,
        message: MISSING_LIVE_STATE_MSG,
      };
    }
    var F = global.WorkshopCityFlow;
    for (var i = 0; i < gids.length; i++) {
      var slot = buildSlotFromLive(gids[i]);
      if (F && F.slotBookable && !F.slotBookable(slot)) {
        var cap = slot.capacity_remaining;
        return {
          bookable: false,
          message:
            cap != null && cap !== '' && Number(cap) <= 0
              ? 'This session is sold out.'
              : closedSessionMessage(slot),
        };
      }
    }
    return { bookable: true };
  }

  function syncCartCapacityBanner(options) {
    options = options || {};
    if (bannerSyncInFlight) return bannerSyncInFlight;

    var guard = global.WorkshopCartCapacityGuard;
    if (!guard) return Promise.resolve({ blocked: false });

    function applyBanner(retryAfterStale) {
      // Missing-event block must win over capacity/live hide paths (rogue lines have no
      // data-wcf-cart-line / GID; validateEventRefs runs first so hideBlockBanner cannot clear it).
      function applyAfterEventRefs() {
        var liveCheck = checkDomBookabilityFromLive();
        if (liveCheck && liveCheck.needsRefresh && !retryAfterStale) {
          return refreshFromDom().then(function () {
            return applyBanner(true);
          });
        }

        function paint(verdict) {
          if (typeof guard.applyCartIssues === 'function') {
            guard.applyCartIssues(verdict || { allowed: true });
            return {
              blocked: !!(verdict && verdict.allowed === false && verdict.validation_unavailable !== true),
            };
          }
          if (verdict && verdict.allowed === false) {
            if (typeof guard.showBlockBanner === 'function') {
              guard.showBlockBanner(verdict.message || guard.defaultMessage);
            }
            return { blocked: true };
          }
          if (typeof guard.hideBlockBanner === 'function') guard.hideBlockBanner();
          return { blocked: false };
        }

        var unverified = {
          allowed: false,
          validation_unavailable: true,
          issues: [],
          message: 'We could not confirm workshop availability. Tap Checkout again. Your cart is unchanged.',
        };

        if (typeof guard.validateCart !== 'function') {
          if (liveCheck && liveCheck.bookable === false && liveCheck.message === MISSING_LIVE_STATE_MSG) {
            return Promise.resolve(paint(unverified));
          }
          if (liveCheck && liveCheck.bookable === false) {
            return Promise.resolve(paint({
              allowed: false,
              message: liveCheck.message || guard.defaultMessage,
              issues: [],
            }));
          }
          return Promise.resolve(paint({ allowed: true }));
        }

        return guard.validateCart(null, 'checkout').then(function (verdict) {
          return paint(verdict);
        });
      }

      if (guard && typeof guard.validateEventRefs === 'function') {
        return guard
          .validateEventRefs()
          .then(function (verdict) {
            if (verdict && verdict.allowed === false) {
              if (typeof guard.applyCartIssues === 'function') {
                guard.applyCartIssues(verdict);
              } else if (typeof guard.showBlockBanner === 'function') {
                guard.showBlockBanner(verdict.message);
              }
              return { blocked: true };
            }
            return applyAfterEventRefs();
          })
          .catch(function () {
            var unverified = {
              allowed: false,
              validation_unavailable: true,
              issues: [],
              message: 'We could not confirm workshop availability. Tap Checkout again. Your cart is unchanged.',
            };
            if (typeof guard.applyCartIssues === 'function') guard.applyCartIssues(unverified);
            else if (typeof guard.showBlockBanner === 'function') guard.showBlockBanner(unverified.message);
            return { blocked: false };
          });
      }
      return applyAfterEventRefs();
    }

    bannerSyncInFlight = (options.skipRefresh ? applyBanner() : refreshFromDom().then(applyBanner).catch(applyBanner)).finally(
      function () {
        bannerSyncInFlight = null;
      }
    );
    return bannerSyncInFlight;
  }

  function isCartSurfaceActive() {
    try {
      if (global.location && global.location.pathname === '/cart') return true;
      var mini = global.Alpine && global.Alpine.store && global.Alpine.store('xMiniCart');
      return !!(mini && mini.open);
    } catch (_) {
      return false;
    }
  }

  function hasWorkshopCartLines() {
    if (collectEventGidsFromDom().length) return true;
    if (global.document && global.document.querySelector('[data-wcf-cart-line="1"]')) return true;
    return false;
  }

  function stopDrawerCapacityPoll() {
    if (drawerPollTimer) {
      clearInterval(drawerPollTimer);
      drawerPollTimer = null;
    }
  }

  function tickDrawerCapacityPoll() {
    if (global.document && global.document.hidden) return;
    if (!isCartSurfaceActive() || !hasWorkshopCartLines()) {
      stopDrawerCapacityPoll();
      return;
    }
    syncCartCapacityBanner();
  }

  function startDrawerCapacityPoll(pollOptions) {
    pollOptions = pollOptions || {};
    stopDrawerCapacityPoll();
    if (!isCartSurfaceActive() || !hasWorkshopCartLines()) return;
    var gates = gatesConfig();
    if (gates.live_fetch_on_cart_open === false) return;
    var ms = cartOpenPollIntervalMs();
    if (!(ms > 0)) return;
    var initialDelay = pollOptions.initialDelayMs != null ? Number(pollOptions.initialDelayMs) : 0;
    if (initialDelay > 0) {
      global.setTimeout(tickDrawerCapacityPoll, initialDelay);
    } else {
      tickDrawerCapacityPoll();
    }
    drawerPollTimer = global.setInterval(tickDrawerCapacityPoll, ms);
  }

  function restartDrawerPoll() {
    if (!isCartSurfaceActive()) {
      stopDrawerCapacityPoll();
      return;
    }
    startDrawerCapacityPoll();
  }

  function bindDrawerPollLifecycle() {
    if (drawerPollBound || !global.document) return;
    drawerPollBound = true;
    global.document.addEventListener('visibilitychange', function () {
      if (global.document.hidden) {
        stopDrawerCapacityPoll();
        return;
      }
      if (isCartSurfaceActive()) {
        startDrawerCapacityPoll();
        syncCartCapacityBanner();
      }
    });
  }

  function clearCartLoadingUi() {
    try {
      var drawer = global.document && global.document.getElementById('CartDrawer');
      if (drawer && global.Alpine && typeof global.Alpine.$data === 'function') {
        var data = global.Alpine.$data(drawer);
        if (data) data.loading = false;
      }
    } catch (_) {}
    try {
      var mini = global.Alpine && global.Alpine.store && global.Alpine.store('xMiniCart');
      if (mini) mini.loading = false;
    } catch (_) {}
  }

  function onCartDrawerOpen() {
    clearCartLoadingUi();
    bindDrawerPollLifecycle();
    splitMergedWorkshopLines()
      .catch(function () {
        return null;
      })
      .finally(function () {
        clearCartLoadingUi();
        syncCartCapacityBanner();
        startDrawerCapacityPoll({ initialDelayMs: 200 });
      });
  }

  function onCartDrawerClose() {
    stopDrawerCapacityPoll();
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshFromDom();
    }, 120);
  }

  function wrapXCartFactory(factory) {
    return function () {
      var api = factory();
      var origPost = api._postUpdateItem.bind(api);

      // Plain qty path: capacity gate then stock Alpine change.js (same-line qty + loading UI).
      api._postUpdateItem = function (itemId, line, qty, maxQty, wait, isShippingInsurance) {
        if (!isWorkshopLineKey(itemId)) {
          return origPost(itemId, line, qty, maxQty, wait, isShippingInsurance);
        }
        gateLineUpdate(itemId, line, qty).then(function (result) {
          if (result.blocked) {
            showLineError(itemId, result.message);
            syncInput(itemId, result.qty);
            finishWorkshopCartUi(api, itemId);
            return;
          }
          clearLineError(itemId);
          origPost(itemId, line, result.qty, result.qty, wait, isShippingInsurance);
        });
      };

      var origPlus = api.plusItemQty.bind(api);
      api.plusItemQty = function (itemId, line, inventory_policy, track_inventory, maxQty) {
        if (!isWorkshopLineKey(itemId)) {
          return origPlus.apply(api, arguments);
        }
        var inp = global.document.getElementById('cart-qty-' + itemId);
        var cur = parseInt((inp && inp.value) || '0', 10) || 0;
        gateLineUpdate(itemId, line, cur + 1).then(function (result) {
          if (result.blocked) {
            showLineError(itemId, result.message);
            syncInput(itemId, result.qty);
            return;
          }
          clearLineError(itemId);
          if (inp) inp.value = result.qty;
          origPost(itemId, line, result.qty, result.qty);
        });
      };

      var origMinus = api.minusItemQty.bind(api);
      api.minusItemQty = function (
        itemId,
        line,
        inventory_policy,
        track_inventory,
        maxQty,
        willRemoveInsurance
      ) {
        if (!isWorkshopLineKey(itemId)) {
          return origMinus.apply(api, arguments);
        }
        var inp = global.document.getElementById('cart-qty-' + itemId);
        var cur = parseInt((inp && inp.value) || '0', 10) || 0;
        var next = cur > 0 ? cur - 1 : 0;
        if (inp) inp.value = next;
        clearLineError(itemId);
        origPost(itemId, line, next, next, 500, willRemoveInsurance);
      };

      var origUpdate = api.updateItemQty.bind(api);
      api.updateItemQty = function (
        itemId,
        line,
        inventory_policy,
        track_inventory,
        maxQty,
        willRemoveInsurance
      ) {
        if (!isWorkshopLineKey(itemId)) {
          return origUpdate.apply(api, arguments);
        }
        var inp = global.document.getElementById('cart-qty-' + itemId);
        var qty = parseInt((inp && inp.value) || '0', 10) || 0;
        if (!api.validateQty(qty)) return;
        gateLineUpdate(itemId, line, qty).then(function (result) {
          if (result.blocked) {
            showLineError(itemId, result.message);
            syncInput(itemId, result.qty);
            return;
          }
          clearLineError(itemId);
          if (inp) inp.value = result.qty;
          origPost(itemId, line, result.qty, result.qty, 500, willRemoveInsurance);
        });
      };

      return api;
    };
  }

  function patchXCart() {
    if (xCartPatched || !global.Alpine || typeof global.Alpine.data !== 'function') return false;
    var factory = global.Alpine.data('xCart');
    if (typeof factory !== 'function') return false;

    global.Alpine.data('xCart', wrapXCartFactory(factory));
    xCartPatched = true;
    return true;
  }

  var alpineDataHooked = false;

  function hookAlpineData() {
    if (alpineDataHooked || !global.Alpine || typeof global.Alpine.data !== 'function') return;
    alpineDataHooked = true;
    var origData = global.Alpine.data.bind(global.Alpine);
    global.Alpine.data = function (name, factory) {
      if (name === 'xCart' && typeof factory === 'function' && !xCartPatched) {
        xCartPatched = true;
        return origData(name, wrapXCartFactory(factory));
      }
      return origData.apply(global.Alpine, arguments);
    };
  }

  function schedulePatchXCart() {
    if (xCartPatched) return;
    hookAlpineData();
    var attempts = 0;
    function tryPatch() {
      if (xCartPatched) return;
      if (patchXCart()) return;
      if (attempts++ < 120) {
        global.setTimeout(tryPatch, 32);
      }
    }
    if (typeof queueMicrotask === 'function') {
      queueMicrotask(tryPatch);
    } else {
      global.setTimeout(tryPatch, 0);
    }
  }

  function boot() {
    schedulePatchXCart();
    scheduleRefresh();
    global.document.addEventListener('eurus:cart:items-changed', scheduleRefresh);
    if (global.location && global.location.pathname === '/cart') {
      bindDrawerPollLifecycle();
      syncCartCapacityBanner().then(function () {
        startDrawerCapacityPoll();
      });
    }
  }

  function diagnoseGateLineUpdate(lineKey, desiredQty) {
    var host = global.document.querySelector('[data-cart-line-key="' + cssEscape(lineKey) + '"]');
    var meta = lineMetaFromEl(host);
    desiredQty = parseInt(desiredQty, 10);
    return refreshLiveForGids(meta && meta.eventGid ? [meta.eventGid] : [], true, { applyMeta: false })
      .then(function (refreshResult) {
        return fetchCart().then(function (cart) {
          var slot = meta && meta.eventGid ? buildSlotFromLive(meta.eventGid) : null;
          var currentQty = currentLineQtyFromDom(lineKey, cart);
          return {
            meta: meta,
            refreshResult: refreshResult,
            cartOk: !!cart,
            currentQty: currentQty,
            desiredQty: desiredQty,
            hasLiveState: meta && meta.eventGid ? hasLiveStateForGid(meta.eventGid) : false,
            hasLiveCapacity: hasLiveCapacity(slot),
            stale: meta && meta.eventGid ? isCapacityStale(meta.eventGid, slot, maxStaleMsBeforeQtyChange()) : null,
            maxForLine:
              cart && meta && meta.eventGid ? maxQtyForLine(cart, lineKey, meta.eventGid, slot) : null,
            liveCacheKeys: Object.keys(liveCache.states || {}),
          };
        });
      });
  }

  global.WorkshopCityCartLive = {
    refreshFromDom: refreshFromDom,
    gateLineUpdate: gateLineUpdate,
    diagnoseGateLineUpdate: diagnoseGateLineUpdate,
    isWorkshopLineKey: isWorkshopLineKey,
    showLineError: showLineError,
    maxQtyForLine: maxQtyForLine,
    buildSlotFromLive: buildSlotFromLive,
    checkDomBookabilityFromLive: checkDomBookabilityFromLive,
    syncCartCapacityBanner: syncCartCapacityBanner,
    onCartDrawerOpen: onCartDrawerOpen,
    onCartDrawerClose: onCartDrawerClose,
    restartDrawerPoll: restartDrawerPoll,
    hasLiveStateForGid: hasLiveStateForGid,
    splitMergedWorkshopLines: splitMergedWorkshopLines,
    normalizeWorkshopSeatGroups: normalizeWorkshopSeatGroups,
    isReady: function () {
      return xCartPatched;
    },
  };

  if (global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  global.document.addEventListener('alpine:init', schedulePatchXCart);
})(typeof window !== 'undefined' ? window : this);
